import "./CompanyPartner.css";

import Google from "../../assets/Google.svg";
import Intel from "../../assets/intel.svg";
import Chubb from "../../assets/chubb.svg";
import Ibm from "../../assets/ibm.svg";
import bny from "../../assets/bny.svg";
import memorial from "../../assets/memorial.svg";
import LinkedIn from "../../assets/linkedin.svg";

const CompanyPartner = () => {
  return (
    <section className="trusted-by-partners-section">
      <div className="container">
        <div className="trusted-by-partners-wrapper">
          <h2>Build Trust With Industry Leading Partners</h2>
          <div className="trusted-by-partners-images row">
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={Google} alt="google" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img
                src={Intel}
                alt="intel"
                loading="lazy"
                width="140"
                height="27"
              />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={Chubb} alt="chubb" loading="lazy" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={Ibm} alt="ibm" loading="lazy" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={memorial} alt="ibm" loading="lazy" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img src={bny} alt="bny-mellon" loading="lazy" />
            </div>
            <div className="col-3 col-sm-2 col-md-2 col-lg-1 partners-icon-col">
              <img
                src={LinkedIn}
                alt="linkedin"
                loading="lazy"
                width="101"
                height="60"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyPartner;
